// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"100":"aee98522","337":"f2e2d22d","376":"3e3843be","585":"228cbecf","787":"9e9f4ffd"}[chunkId] + ".chunk.js";
};